export class PhotoSliderModule {
    initialize() {
        this.sliders = document.querySelectorAll('.photo-slider');
        this.sliders.forEach(slider => {
            new PhotoSlider().initialize(slider);
        });
    }
}   

class PhotoSlider {
    initialize(slider) {
        this.rootElement = slider;
        this.images = this.rootElement.querySelectorAll('.photo-slider-image');

        this.preview = this.rootElement.querySelector(".photo-slider-preview");
        this.previewImg = this.preview.querySelector(".photo-slider-preview-image");
        this.previewPrevButton = this.preview.querySelector(".photo-slider-preview-prev");
        this.previewNextButton = this.preview.querySelector(".photo-slider-preview-next");
        this.previewCloseButton = this.preview.querySelector(".photo-slider-preview-close");

        this.horizontalScrollContainer = this.rootElement.querySelector('horizontal-scroll-container');
        this.horizontalScroll = this.horizontalScrollContainer.querySelector('.horizontal-scroll');
        this.horizontalScrollItems = this.horizontalScroll.querySelectorAll('.navigation-item');


        // The minimal width for zooming is the breakpoint-md from Bootstrap
        const breakpointMd = getComputedStyle(document.documentElement).getPropertyValue('--bs-breakpoint-md');
        this.minimalWidthForZoom = Number(breakpointMd.replace('px', ''));

        this.activeImageIndex = -1; // not set

        this.setEventListeners();
    }

    setEventListeners() {
        this.images.forEach(image => {
            image.addEventListener('click', () => {
                this.onImageClick(image);
            });
        });

        this.previewPrevButton.addEventListener('click', () => {
            this.previousImage();
        });

        this.previewNextButton.addEventListener('click', () => {
            this.nextImage();
        });

        this.preview.addEventListener('click', (event) => {
            if (event.target === this.preview) {
                this.closePreview();
            }
        });

        this.previewCloseButton.addEventListener('click', () => {
            this.closePreview();
        });

        window.addEventListener('resize', () => {
            // Zoom has not a lot of function on mobile devices, because of the size
            if (window.innerWidth < this.minimalWidthForZoom) {
                this.closePreview();
            }
        });

        // Next/previous image when using arrow keys, close preview with escape
        document.addEventListener('keydown', (event) => {
            if (this.activeImageIndex === -1) return;

            if (event.key === "Escape") {
                this.closePreview();
            } else if (event.key === "ArrowLeft") {
                event.preventDefault();
                this.previousImage();
            } else if (event.key === "ArrowRight") {
                event.preventDefault();
                this.nextImage();
            }
        });
    }

    onImageClick(image) {
        this.activeImageIndex = parseInt(image.dataset.index);

        this.setHorizontalScrollPosition();
        this.renderButtons();

        this.previewImg.src = image.dataset.src;
        this.preview.classList.remove("hidden");
        
        // Add class to body when photo slider is open
        document.body.classList.add("photo-slider-open");
    }

    setHorizontalScrollPosition() {
        this.horizontalScrollContainer.dataset.currentItem = this.activeImageIndex;
        
        if (this.horizontalScrollItems && this.horizontalScrollItems[this.activeImageIndex]) {
            const targetItem = this.horizontalScrollItems[this.activeImageIndex];
            const firstItem = this.horizontalScrollItems[0];
            
            if (targetItem && firstItem) {
                let leftOffsetCalculation = targetItem.offsetLeft - firstItem.offsetLeft;
                this.horizontalScroll.scroll({ top: 0, left: leftOffsetCalculation });
            }
        }
    }

    renderButtons() {
        // Hide buttons if first or last image

        if (this.activeImageIndex === 0) {
            this.previewPrevButton.classList.add("hidden");
        } else {
            this.previewPrevButton.classList.remove("hidden");
        }

        if (this.activeImageIndex === this.images.length - 1) {
            this.previewNextButton.classList.add("hidden");
        } else {
            this.previewNextButton.classList.remove("hidden");
        }
    }

    closePreview() {
        this.preview.classList.add("hidden");
        this.activeImageIndex = -1;
        
        // Remove class from body when photo slider is closed
        document.body.classList.remove("photo-slider-open");
    }

    previousImage() {
        if (this.activeImageIndex < 1) return;

        const image = this.images[this.activeImageIndex - 1];
        if (image) this.onImageClick(image);
    }


    nextImage() {
        if (this.activeImageIndex >= this.images.length) return;

        const image = this.images[this.activeImageIndex + 1];
        if (image) this.onImageClick(image);
    }
}